export default __webpack_public_path__ + "static/media/fauna-qs-top.334ba56a.png";